export default __webpack_public_path__ + "static/media/glasgow.d843a54e.jpeg";